// extracted by mini-css-extract-plugin
module.exports = {"calendar":"calendar_calendar__s_gwO","headerRow":"calendar_headerRow__07N1E","headerLabel":"calendar_headerLabel__VtpfX","eventList":"calendar_eventList__Wr30b"};